export const requestClientInterceptor = (config) => {
  const { accessToken, tokenParsed } = window
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  // Adicionar idioma de processamento no header
  const processingLanguage = getProcessingLanguage(tokenParsed)
  if (processingLanguage) {
    config.headers['x-daai-language'] = processingLanguage
  }
  return config
}

export const requestClientInterceptorWithoutLanguage = (config) => {
  const { accessToken } = window
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
}

// Função para obter o idioma de processamento
const getProcessingLanguage = (token) => {
  try {
    if (token?.sub) {
      const key = `language_config_${token.sub}`
      const saved = localStorage.getItem(key)
      if (saved) {
        const config = JSON.parse(saved)
        return config?.processingLanguage?.split('-')[0] || 'pt'
      }
    }
    // 2. Fallback: usar locale do token se disponível
    if (token?.locale) {
      return token.locale.split('-')[0] || 'pt'
    }
    // 3. Fallback final: usar pt-BR
    return 'pt'
  } catch (error) {
    console.error('Erro ao obter idioma de processamento:', error)
    return 'pt'
  }
}
